import { loadConfig } from './loadConfig';
import { attachButtonsHandler } from './attachButtonsHandler';
import { initConfigPerURL } from '../url-config';
import { getDeviceType } from '../device';
import { watchForURLChange } from '../url-config/url-change';
import { configHandler } from './configHandler';

const init = (configUrl) => {
    loadConfig(configUrl, (config) => {
        attachButtonsHandler(config);
        if (getDeviceType() !== 'mo_app') {
            watchForURLChange(() => {
                initConfigPerURL({
                    launchConfigCallback: (config) => {
                        configHandler(config);
                    }
                });
            });

            initConfigPerURL({
                launchConfigCallback: (config) => {
                    configHandler(config);
                }
            });
        }
    });
};

export { init };
